"use strict";

angular.module('app.modals.deviceLogSettings', [])

    .controller('deviceLogSettingsModalCtrl', ['$scope', '$state', 'close', 'f_User', '$q', 'LogDevice', 'LogDatapoint','Params',
        function ($scope, $state, close, f_User, $q, LogDevice, LogDatapoint,Params) {


            var DeviceDefault =
            {
                    LoggingServerEnabled: false,
                    LoggingLocalEnabled :false,
                    StatisticEnabled :false,
                    ForceLoggingInterval :1800

            }
            var DatapointDefault =
            {
                LoggingServerEnabled: false,
                LoggingLocalEnabled :false,
                StatisticEnabled :false,
                ReadInterval :60,
                Hysteresis :1

            };
            $scope.init = function(){
                $scope.Params = Params;
                if(LogDevice)
                {
                    $scope.LogDevice = angular.extend(DeviceDefault,LogDevice);
                }
                if(LogDatapoint){
                    //LogDatapoint.DatapointValue = LogDatapoint.DatapointValue.$encode();
                   // var d = LogDatapoint;
                   // delete d.DatapointValue;
                    $scope.LogDatapoint = angular.extend(DatapointDefault,LogDatapoint);
                   // $scope.LogDatapoint.DatapointValue = LogDatapoint.DatapointValue;
                }

                $scope.User = f_User;
                //console.log($scope.LogDatapoint);

            };



            $scope.close = function (a) {
                if (!a) {
                    close();
                } else {
                    // check which type to return;
                    // close();
                    if(LogDatapoint != undefined)
                    {
                        if ($scope.LogDatapoint.Hysteresis
                            && $scope.LogDatapoint.Hysteresis.length
                            && $scope.LogDatapoint.Hysteresis.length > 0
                            && $scope.LogDatapoint.Hysteresis.indexOf(',') > -1) {
                            $scope.LogDatapoint.Hysteresis = $scope.LogDatapoint.Hysteresis.replace(/,/g, '.'); 
                        }
                        a = $scope.LogDatapoint;
                    }else{
                        a = $scope.LogDevice;
                    }
                    close(a);
                }
            }

            $scope.init();
        }
    ])

    .factory('deviceLogSettingsModal', ['ModalService', '$q', function (ModalService, $q) {
        return function (LogDevice,LogDatapoint,Params) {

            return ModalService.showModal({
                templateUrl: "views/modals/deviceLogSettings.html",
                controller: 'deviceLogSettingsModalCtrl',
                inputs: {
                    LogDatapoint: LogDatapoint,
                    LogDevice: LogDevice,
                    Params : Params
                }
            });


        }
    }]);
